import { createBrowserHistory } from "history/cjs/history.min";
import AppUtil from "./AppUtil";
import RoutePath from "./RoutePath";

export function logoutUtil() {
  AppUtil.removeJwtToken();
  createBrowserHistory().push(RoutePath.APP_LOGIN);
  window.location.reload()
}
